/** 合规文件下载路径片段（与 uploadService 一致） */
const FILE_GET_PREFIX = '/client/compliance/file/get/';

/**
 * 修复后端错误拼接的合规文件 URL，例如：
 * https://host//client/compliance/file/gethttps://host/client/compliance/file/get/xxx.jpg?accesskey=a?accesskey=b
 *
 * 规则：取最后一次出现的 `/client/compliance/file/get/` 后的文件名；存在多个 `accesskey` 时取最后一个。
 * 非 http(s) 的相对路径原样返回。
 */
export function normalizeComplianceFileResourceUrl(raw: string): string {
  if (!raw || typeof raw !== 'string') return raw;
  const trimmed = raw.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const hostMatch = trimmed.match(/^(https?:\/\/[^/]+)/i);
  if (!hostMatch) return trimmed;
  const host = hostMatch[1];

  const duplicatedAccessKey = /\?accesskey=[^?]+\?accesskey=/i.test(trimmed);
  const gluedGet =
    /gethttps:\/\//i.test(trimmed) ||
    /gethttp:\/\//i.test(trimmed) ||
    /\/\/client\/compliance\/file\/gethttps/i.test(trimmed);

  const needsExtract = duplicatedAccessKey || gluedGet;

  if (!needsExtract) {
    if (trimmed.includes(`${host}//client`)) {
      return `${host}/${trimmed.slice(host.length + 2)}`.replace(/([^:])\/{2,}client/g, '$1/client');
    }
    return trimmed;
  }

  const lastIdx = trimmed.lastIndexOf(FILE_GET_PREFIX);
  if (lastIdx === -1) return trimmed;

  const rest = trimmed.slice(lastIdx + FILE_GET_PREFIX.length);
  const qPos = rest.indexOf('?');
  const filePart = qPos === -1 ? rest : rest.slice(0, qPos);
  const queryPart = qPos === -1 ? '' : rest.slice(qPos + 1);

  const keyMatches = [...queryPart.matchAll(/accesskey=([^?&]+)/gi)];
  const accesskey = keyMatches.length ? keyMatches[keyMatches.length - 1][1] : '';

  const pathEnc = encodePathSegments(filePart);
  if (!accesskey) {
    return `${host}${FILE_GET_PREFIX}${pathEnc}`;
  }
  return `${host}${FILE_GET_PREFIX}${pathEnc}?accesskey=${accesskey}`;
}

function encodePathSegments(fileName: string): string {
  if (!fileName) return fileName;
  return fileName
    .split('/')
    .map((seg) => {
      if (!seg) return seg;
      try {
        return encodeURIComponent(decodeURIComponent(seg));
      } catch {
        return encodeURIComponent(seg);
      }
    })
    .join('/');
}
